import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import axiosConfig from "../../../services/Axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListCheck } from "@fortawesome/pro-regular-svg-icons";
import Pagination from "../../../components/ui/Pagination";
import Title from "../../../components/ui/Title";
import dayjs from "dayjs";
import EmptyData from "../../../components/ui/EmptyData";
import SearchPurchaseOrder from "../../../components/ui/Forms/SearchPurchaseOrder";
import { faCloudUploadAlt } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import OrderList from "./OrderList";

function Orders() {
  const [orders, setOrders] = useState();
  const [formData, setFormData] = useState();
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");
  const { t } = useTranslation();

  useEffect(() => {
    if (!formData) return;
    loadOrders(formData);
  }, [formData]);

  const loadOrders = (formData) => {
    let itemsPerPage = 10;
    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/purchase_orders?");

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    if (formData?.partner) {
      url = url + "&partner.name=" + formData.partner;
    }

    if (formData?.state) {
      url = url + "&state=" + formData.state;
    }

    if (formData?.pieceNumber) {
      url = url + "&pieceNumber=" + formData.pieceNumber;
    }

    if (formData?.startDate) {
      url =
        url +
        "&createdAt[after]=" +
        dayjs(formData.startDate).format("YYYY-MM-DD 00:00:00");
    }

    if (formData?.endDate) {
      url =
        url +
        "&createdAt[before]=" +
        dayjs(formData.endDate).format("YYYY-MM-DD 23:59:59");
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setOrders(response.data);
      }
    });
  };

  const handleExportPurchasOrder = (data) => {
    const params = {
      startDate: data.startDate
        ? dayjs(data.startDate).format("YYYY-MM-DD 00:00:00")
        : null,
      endDate: data.endDate
        ? dayjs(data.endDate).format("YYYY-MM-DD 23:59:59")
        : null,
      partner: data.partner ? data.partner : null,
      pieceNumber: data.pieceNumber ? data.pieceNumber : null,
      state: data.state ? data.state : null,
    };

    let filename = "export-commandes-" + dayjs().format("YYYY-MM-DD-HH:mm");

    axiosConfig
      .post(
        process.env.REACT_APP_API_URL + "/api/purchase-orders/export",
        params,
        {
          responseType: "arraybuffer",
        }
      )
      .then(async (response) => {
        if (response.data) {
          let b = new Blob([response.data]);
          const url = window.URL.createObjectURL(b);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename + ".csv");
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white  rounded-lg">
          <div className="grid grid-cols-12">
            <div className="col-span-12">
              <Title
                icon={faListCheck}
                title={
                  isAdmin
                    ? t("settings.orders.list")
                    : t("settings.orders.listUser")
                }
              />
            </div>
          </div>

          <SearchPurchaseOrder setFormData={setFormData} formData={formData} />
          {orders && (
            <>
              <Title
                title={t("global.resultCount", {
                  count: orders["hydra:totalItems"] ?? 0,
                })}
                className="mt-4"
                button={
                  isAdmin
                    ? {
                        icon: <FontAwesomeIcon icon={faCloudUploadAlt} />,
                        label: t("global.export"),
                        fn: () => handleExportPurchasOrder(formData),
                      }
                    : null
                }
              />

              {orders["hydra:totalItems"] > 0 ? (
                <OrderList
                  orders={orders}
                  setOrders={setOrders}
                  loadOrders={loadOrders}
                />
              ) : (
                <EmptyData className="mt-3">{t("global.no-result")}</EmptyData>
              )}
              {orders["hydra:member"] &&
                orders["hydra:totalItems"] > orders["hydra:member"].length &&
                orders["hydra:view"] && (
                  <Pagination
                    data={orders}
                    onClick={(page) => {
                      setFormData((formData) => ({
                        ...formData,
                        page: page,
                      }));
                    }}
                  />
                )}
            </>
          )}
        </div>
      </div>
    </Base>
  );
}

export default Orders;
